/* eslint-disable no-unused-vars */
import { ModalBase, ModalHeader, ModalFooter, Loader } from 'components';
import { ColumnsSection } from './ColumnsSection';
import { EventsSection } from './EventsSection';

import { useFacade } from './useFacade';

import * as S from './ExportTableModal.styled';

export const ExportTableModal = ({ isOpen$, title }) => {
  const {
    campaignSettings$,
    metrics$,
    events$,
    isAllCampaignSelected$,
    isAllMetricsSelected$,
    isAllEventsSelected$,
    isLoading$,
    handleSave,
    handleCampaignAll,
    handleCampaign,
    handleMetrics,
    handleMetricsAll,
    handleEvents,
    handleEventsAll,
    cancelExport,
  } = useFacade(isOpen$);

  return (
    <ModalBase>
      {isLoading$.value ? (
        <S.ExportLoader
          onClick={() => {
            isOpen$.value = false;
          }}
        >
          <S.LoaderContent>
            <div style={{ flexBasis: '50px' }}>
              <Loader.Local />
            </div>
            <S.LoaderTextWrap>
              <S.LoaderText>Preparing the file for export ...</S.LoaderText>
              <S.LoaderTextSmall>File download will start automatically</S.LoaderTextSmall>
            </S.LoaderTextWrap>
          </S.LoaderContent>
        </S.ExportLoader>
      ) : (
        <>
          <ModalHeader
            title={title}
            close={() => {
              isOpen$.value = false;
            }}
          />
          <S.Box>
            <ColumnsSection
              campaignSettings={campaignSettings$.value}
              isAllCampaignSelected={isAllCampaignSelected$.value}
              onHandleCampaign={handleCampaign}
              onHandleCampaignAll={handleCampaignAll}
            />
            <EventsSection
              metrics={metrics$.value}
              isAllMetricsSelected={isAllMetricsSelected$.value}
              onHandleMetrics={handleMetrics}
              onHandleMetricsAll={handleMetricsAll}
              events={events$.value}
              isAllEventsSelected={isAllEventsSelected$.value}
              onHandleEvents={handleEvents}
              onHandleEventsAll={handleEventsAll}
            />
          </S.Box>
          <ModalFooter
            saveButtonText='Export'
            saveButtonOnClick={handleSave}
            close={() => {
              isOpen$.value = false;
            }}
            saveButtonDisabled={false}
          />
        </>
      )}
    </ModalBase>
  );
};
